import Modal from 'components/Modal';
import Button from 'components/Button';
import React from 'react';
import PropTypes from 'prop-types';
import {
  CANCEL_SUCCESS_TEXT,
  DEFAULT_ERROR_TEXT,
} from 'modules/Contacts/components/Appointment/constants';

function InfoModal({ isShowModal, isCanceled, onClose }) {
  return (
    <Modal showModal={isShowModal} onClose={onClose}>
      <h2>Отмена посещения</h2>
      <div className="page_margin30">{isCanceled ? CANCEL_SUCCESS_TEXT : DEFAULT_ERROR_TEXT}</div>
      <div className="form_buttons form_buttons__right">
        <Button value="Закрыть" hasWrapper={false} color="blue" size="medium" onClick={onClose} />
      </div>
    </Modal>
  );
}

InfoModal.propTypes = {
  isShowModal: PropTypes.bool,
  isCanceled: PropTypes.bool,
  onClose: PropTypes.func,
};
export default InfoModal;
